<template>
  <row-card @click="click"
  :imageUrl="companyImage"
  :leftTitle="job.title"
  :rightTitle="salary"
  :rightSubtitle="jobType">
  <template slot="leftSubtitle">
    <div>
      <job-locations :locations="job.locations" :remote="job.isRemoteAvailable">
        <template slot="prefix">
          {{company}} <span v-if="showSeprator">• </span>
        </template>
      </job-locations>
    </div>
    </template>
  </row-card>
</template>

<script>
import RowCard from '../general/row-card'
import JobSalary from '@/components/general/job-salary'
import JobLocations from '@/components/jobs/job-locations'

export default {
  components: {
    RowCard,
    JobSalary,
    JobLocations
  },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  computed: {
    jobType () {
      return this.job.jobTypeName || this.job.contract
    },
    company () {
      return this.job.companyName || this.job.company
    },
    salary () {
      return JobSalary.methods.salary(this.job)
    },
    showSeprator () {
      if (this.job.locations.length > 0) {
        return true
      }
      if (this.job.isRemoteAvailable) {
        return true
      }
    },
    companyImage () {
      return this.job.companyImageUrl || `/api/identicons/${this.job.companyId}`
    }
  },
  methods: {
    click (event) {
      this.$emit('click', {'event': event, 'jobid': this.job.id})
    },
    usdFormat (value) {
      return `$${value.toLocaleString()}`
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-row-card.vue